import { AllowedPLNavRoutes, PLSubmissionRoutes } from './pl-menus.model';
import { AllowedPRNavRoutes, PRSubmissionRoutes } from './pr-menus.model';
import { AllowedBRNavRoutes, BRSubmissionRoutes } from './br-menus.model';
import { AllowedGLNavRoutes, GLSubmissionRoutes } from './gl-menus.model';
import { AllowedEXNavRoutes, EXSubmissionRoutes } from './ex-menus.model';
import { AllowedCENavRoutes, CESubmissionRoutes } from './ce-menus.model';

export enum AllowedRoutes {
  Login = 'login',
  RequestAccess = '/request-access',
  Dashboard = '/dashboard',
  NewsFeed = '/news-feed',
  ContactUs = '/contact-us',
  AccountSettings = '/account-settings/updatephone',
  AgencyAdmin = '/agency-admin/main',
  AddNewAgent = '/agency-admin/add-new-user',
  BaseUrl='/'
}

export const ProductsNavRoutes = {
  'General Liability': AllowedGLNavRoutes,
  'Pollution Liability': AllowedPLNavRoutes,
  'Professional Liability': AllowedPRNavRoutes,
  "Builders' Risk": AllowedBRNavRoutes,
  'Excess Liability': AllowedEXNavRoutes,
  "Contractors' Equipment": AllowedCENavRoutes
};

export const SubmissionType = {
  'General Liability': GLSubmissionRoutes,
  'Pollution Liability': PLSubmissionRoutes,
  'Professional Liability': PRSubmissionRoutes,
  "Builders' Risk": BRSubmissionRoutes,
  'Excess Liability': EXSubmissionRoutes,
  "Contractors' Equipment": CESubmissionRoutes
};

export enum ProductType {
  General = 'General Liability',
  Pollution = 'Pollution Liability',
  Professional = 'Professional Liability',
  Builders = "Builders' Risk",
  Excess = 'Excess Liability',
  Contractors = "Contractors' Equipment",
  RemodelingGL = 'Remodeling GL'
}

export enum UcmUrl {
  General = 'ucm',
  Pollution = 'PL_ucm',
  Professional = 'PR_ucm',
  Builders = 'BR_ucm',
  Excess = 'EX_ucm',
  Contractors = 'CE_ucm'
}

export enum ProductStepsUrl {
  General = 'steps',
  Pollution = 'PollutionLiability',
  Professional = 'ProfessionalLiability',
  Builders = 'BuildersRisk',
  Excess = 'ExcessLiability',
  Contractors = 'ContractorsEquipment',
  Bound = 'Bound'
}

export enum StepOneRoutes {
  Insured = 'insured',
  Owner = 'owner',
  Ratings = 'rating',
  Jobsite = 'jobsite',
  Equipment = 'equipment'
}

export enum EditCoverage {
  GeneralLiability = 'General Liability',
  ExcessLiability = 'Excess Liability',
  Contractors = 'Contractors Personal Property',
  BuildersRisk = "Builders' Risk",
  ContractorsEquipment = "Contractors' Equipment",
  ContractorsLossPayee = 'Loss Payee / Mortgagee',
  PollutionLiability = 'Pollution Liability',
  BuildersLossPayee = 'Loss Payee / Mortgagee / Additional Insured',
  ProfessionalLiability = 'Professional Liability',
  AutomobileCoverages = 'Automobile Coverages',
  EmployeeBenefitsLiabilityCoverage = 'Employee Benefits Liability Coverage',
  EmployersLiabilityCoverage = 'Employers Liability Coverage (Stop Gap)'
}

export enum HeaderMenu {
  NewsFeed = 'News Feed',
  Dashboard = 'Dashboard',
  Search = 'Search',
  CustomerService = 'Customer Service',
  Settings = 'Settings',
  Logout = 'Logout',
  Artisan = 'artisan',
  AccountSettings = 'Account Settings',
  Surety = 'Surety',
  BaseUrl = 'BaseUrl',
  AgencyAdmin = 'Agency Admin'
}
export enum FooterMenu {
  ContactUs = 'CONTACT US',
  News = 'NEWS'
}

export enum BoundDropdownMenu {
  FileClaim = 'File a Claim',
  AskQuestion = 'Ask a Question',
  EndorsePolicy = 'Endorse Policy',
  GenerateLossRun = 'Generate Loss Run'
}

export enum UpdatePolicy {
  Step1AUpdate = 'Step1AUpdate',
  Step1BUpdate = 'Step1BUpdate',
  Step1CUpdate = 'Step1CUpdate',
  Step2AUpdate = 'Step2AUpdate',
  Step2BUpdate = 'Step2BUpdate',
  Step2CUpdate = 'Step2CUpdate',
  Step3AUpdate = 'Step3AUpdate',
  Step3BUpdate = 'Step3BUpdate',
  Step3CUpdate = 'Step3CUpdate',
  EHelpUWReview = 'EHelpUWReview'
}

export enum UCMBackEventName {
  Step1BBackClicked = 1,
  Step1CBackClicked = 2,
  Step2ABackClicked = 3,
  Step2BBackClicked = 4,
  Step2CBackClicked = 5,
  Step3ABackClicked = 6,
  Step3BBackClicked = 7,
  Step3CBackClicked = 8
}

export enum UCMEventName {
  Step1NextClicked = "Step1NextClicked",
  Step1SearchClicked = 'Step1SearchClicked',
  Step1ANextClicked = 'Step1ANextClicked',
  Step1BNextClicked = 'Step1BNextClicked',
  Save1B = 'Save1B',
  Step1BBackClicked = 'Step1BBackClicked',
  Step1CNextClicked = 'Step1CNextClicked',
  Save1C = 'Save1C',
  Step1CBackClicked = 'Step1CBackClicked',

  Step2ANextClicked = 'Step2ANextClicked',
  Save2A = 'Save2A',
  Step2ABackClicked = 'Step2ABackClicked',
  Step2BNextClicked = 'Step2BNextClicked',
  Save2B = 'Save2B',
  Step2BBackClicked = 'Step2BBackClicked',
  Step2CNextClicked = 'Step2CNextClicked',
  Step2DNextClicked = 'Step2DNextClicked',
  Save2C = 'Save2C',
  Step2CBackClicked = 'Step2CBackClicked',

  Step3ANextClicked = 'Step3ANextClicked',
  Save3A = 'Save3A',
  Step3ABackClicked = 'Step3ABackClicked',
  Step3ASubmitClicked = 'Step3ASubmitClicked',
  Step3BNextClicked = 'Step3BNextClicked',
  Step3BSubmitClicked = 'Step3BSubmitClicked',
  Save3B = 'Save3B',
  Step3BBackClicked = 'Step3BBackClicked',
  Save3C = 'Save3C',
  Step3CBackClicked = 'Step3CBackClicked',
  ModifyCoveragesClicked = 'ModifyCoveragesClicked',
  SaveAndContinueClickedEvent = 'SaveAndContinueClickedEvent',
  RenewalContinueClicked = 'RenewalContinueClicked',

  SaveClicked = 'SaveClicked',
  SaveAndContinueClicked = 'SaveAndContinueClicked',

  RatingChanged = 'RatingChanged',
  APIResultEvent = 'APIResultEvent',

  DownloadQuoteClicked = 'DownloadQuoteClicked',
  DownloadProposalDocumentEvent = 'DownloadProposalDocumentEvent',

  //SurplusLine Form Events
  DownloadAndSign = 'downloadAndSign',
  Cancel = 'Cancel',
  PreviewForm = 'previewForm',
  SaveAndSend = 'saveAndSend',
  InsuredNextClick = 'insuredNextClick',

  // Others Events
  StartActivityIndicator = 'StartActivityIndicator',
  StopActivityIndicator = 'StopActivityIndicator',
  Step4DwnloadDoc = 'Step4DwnloadDoc',
  PerformPolicyTypeValidation = 'PerformPolicyTypeValidation',

  // Endorsement Popup Events
  StartNewEndorsement = 'StartNewEndorsement',
  ContinueEndorsement = 'ContinueEndorsement',
  CreateEndorsement = 'CreateEndorsement',
  CancelEndorsement = 'CancelEndorsement',

  //Endorsement: Address Change
  SaveAddChange = 'SaveAddChange',
  StepENAddNextClicked = 'StepENAddNextClicked',
  Declined = 'Declined',
  SaveAddReview = 'SaveAddReview',
  IssueEndorsement = 'IssueEndorsement',

  //Endorsement: Exposure Change
  SubmitENAdd = 'SubmitENAdd',
  StepENExpSave = 'StepENExpSave',
  StepENExpNext = 'StepENExpNext',
  StepENExpBack = 'StepENExpBack',
  StepENExpReviewSave = 'StepENExpReviewSave',
  StepENExpSubmit = 'StepENExpSubmit',

  //Endorsement: Classification Change
  StepENClassSave = 'StepENClassSave',
  StepENClassNext = 'StepENClassNext',
  StepENClassBack = 'StepENClassBack',
  StepENClassRvwSave = 'StepENClassRvwSave',
  StepENClassSubmit = 'StepENClassSubmit',
  NextClicked = 'NextClicked',
  StartActivityDeclineVP='StartActivityDeclineV&P',

  //Endorsement: Address Change Declined- Diff State Address 
  StartActivityDeclineSave='StartActivityDeclineSave',
  StartActivityDeclineNext='StartActivityDeclineNext'
}

export enum PolicyStatus {
  DeclinedNB = 'Declined New Business',
  PendingUWReview = 'EHelpUWReview'
}	

export enum GeneralPageName {
  Declined = 'Declined',
  PendingUWReview = 'EHelpUWReview'
}	